import { MdEuro, MdOutlineAttachMoney } from 'react-icons/md';
import { FiDollarSign } from 'react-icons/fi';

export const BACKEND_URL = 'https://viral-app-59mqm.ondigitalocean.app';
// export const BACKEND_URL = 'http://localhost:3001';
export const USD_PRODUCT_ID = 'prod_MS19OcxXEiaB0M';
export const EUR_PRODUCT_ID = 'prod_MTuuDhutVFBTq3';

export const links = [
    {
      title: 'Stripe',
      links: [
        {
          name: 'Links (USD)',
          url: 'links_usd',
          icon: <MdOutlineAttachMoney/>,
        },
        {
          name: 'Links (EUR)',
          url: 'links_eur',
          icon: <MdEuro/>,
        },
        {
          name: 'Pagos',
          url: 'pagos',
          icon: <FiDollarSign />,
        },
      ],
    },
    /*
    {
      title: 'Zelle',
      links: [
        {
          name: 'Pagos',
          url: 'zelle',
          icon: <FiDollarSign />,
        },
      ],
    },
    */
  ];